import React from "react";
import logo from "../../assets/images/pexels-jimmy-teoh-294331-951539.jpg";
import { motion } from "framer-motion";
import { FaCalendarAlt, FaPhoneAlt } from "react-icons/fa";

const Hero = () => {
  const handleScrollToForm = () => {
    const formElement = document.getElementById("transfer-form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="relative w-full min-h-screen flex items-center justify-center overflow-hidden md:pt-0 md:pb-0 pt-48 pb-12">
      {/* Background image with gradient overlays and animated blobs */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${logo})`,
        }}
        aria-hidden="true"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-gray-900/70 to-slate-900/80" />
      </div>
      {/* Decorative animated blobs */}
      <div className="absolute -top-32 -left-32 w-[28rem] h-[28rem] bg-gray-500/30 rounded-full blur-3xl z-0 animate-pulse-slow" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-400/20 rounded-full blur-3xl z-0 animate-pulse-slow" />

      {/* Hero content */}
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          className="max-w-2xl mx-auto bg-white/10 backdrop-blur-2xl p-12 rounded-3xl shadow-2xl border border-white/20"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1
            className="text-4xl md:text-6xl font-extrabold text-center mb-4 text-transparent bg-clip-text bg-gradient-to-r from-indigo-200 via-white to-blue-200 drop-shadow-2xl animate-fadeIn"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Athens Transfers & Tours
          </motion.h1>
          <motion.h2
            className="text-2xl md:text-3xl font-semibold text-center mb-8 text-white/90 drop-shadow-lg animate-fadeIn"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Your Journey, Our Passion – Anywhere, Anytime in Athens
          </motion.h2>
          <motion.p
            className="text-lg md:text-xl text-center mb-8 text-white/80 font-medium animate-fadeIn"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Experience seamless <span className="text-indigo-200 font-semibold">Athens airport transfers</span> and exclusive <span className="text-indigo-100 font-semibold">private tours</span>. Book in seconds and travel with comfort, safety, and style.
          </motion.p>

          <motion.div
            className="w-full h-px bg-gradient-to-r from-indigo-400 via-white to-blue-400 mb-10"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1, delay: 0.8 }}
          />

          <motion.div
            className="flex flex-col md:flex-row gap-6 justify-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
          >
            <motion.button
              onClick={handleScrollToForm}
              className="group bg-gradient-to-r from-indigo-700 via-blue-700 to-blue-900 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-xl hover:from-blue-900 hover:to-indigo-700 transition-all duration-300 border-2 border-white/20 hover:border-indigo-400 flex items-center justify-center focus:outline-none focus:ring-4 focus:ring-indigo-400/50"
              whileHover={{ scale: 1.07 }}
              whileTap={{ scale: 0.96 }}
            >
              <FaCalendarAlt className="mr-3 text-2xl group-hover:animate-wiggle" />
              <span>Book Your Transfer</span>
            </motion.button>
            <motion.a
              href="tel:+306932214626"
              className="group bg-gradient-to-r from-blue-700 via-indigo-700 to-purple-900 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-xl hover:from-indigo-900 hover:to-blue-700 transition-all duration-300 border-2 border-white/20 hover:border-blue-400 flex items-center justify-center focus:outline-none focus:ring-4 focus:ring-blue-400/50"
              whileHover={{ scale: 1.07 }}
              whileTap={{ scale: 0.96 }}
            >
              <FaPhoneAlt className="mr-3 text-2xl group-hover:animate-wiggle" />
              <span>Call Us Now</span>
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
